import _cloneDeep from 'lodash/cloneDeep'
import _isEqual from 'lodash/isEqual'
import _orderBy from 'lodash/orderBy'
import { fetchImprovementIdeaCategories, getImprovementIdeasStats, getKpiCardImprovementIdeas } from "frontend/communications/improvementIdeas"
import { IMPROVEMENT_IDEA_RELATIONSHIPS } from 'frontcore/constants/improvementIdeaConstants'

const stateObj = {
  categories: [],
  improvementIdeaStatsCache: null,
  improvementIdeaCachedFilters: null,
  gembaWalkKPIImprovementIdeas: [],

}

const getters = {
  improvementIdeaCategories (state) {
    return state.categories.filter(category => category.enabled)
  },
  getImprovementIdeaCategoryById: (state) => (id) => {
    return state.categories.find(category => category.id === id)
  },
  getImprovementIdeaByGembaWalkKPIId: (state) => (kpiId) => {
    return state.gembaWalkKPIImprovementIdeas.filter(_improvementIdea => _improvementIdea[IMPROVEMENT_IDEA_RELATIONSHIPS.kpiCard] === kpiId)
  },
  improvementIdeaStats: state =>  filters => {
    if (state.improvementIdeaStatsCache && _isEqual(filters, state.improvementIdeaCachedFilters)) {
      return state.improvementIdeaStatsCache
    }
    state.improvementIdeaCachedFilters = _cloneDeep(filters)
    state.improvementIdeaStatsCache = getImprovementIdeasStats(filters)
    return state.improvementIdeaStatsCache
  },
}

const mutations = {
  setImprovementIdeaCategories (state, categories) {
    state.categories = _orderBy(categories, 'name')
  },
  setGembaWalkKPIImprovementIdeas: (state, improvementIdeas) => {
    state.gembaWalkKPIImprovementIdeas = improvementIdeas
  },
  updateImprovementIdeaCategory (state, value) {
    const categoryIndex = state.categories.findIndex(category => category.id === value.id)
    if (categoryIndex !== -1) {
      state.categories.splice(categoryIndex, 1, value)
    }
  },
}

const actions = {
  fetchImprovementIdeaCategories ({ commit }) {
    return fetchImprovementIdeaCategories()
      .then((categories) => {
        commit('setImprovementIdeaCategories', categories)
      })
  },
  fetchImprovementIdeasByGembaWalkKPIId: ({ commit }, entityId) => {
    return getKpiCardImprovementIdeas(entityId)
      .then(improvementIdeas => {
        commit('setGembaWalkKPIImprovementIdeas', improvementIdeas)
        return improvementIdeas
      })
      .catch(e => {
        commit('setGembaWalkKPIImprovementIdeas', [])
        throw e
      })
  },
}

export default {
  actions,
  getters,
  mutations,
  state: stateObj,
}
